export const PILOT_MODULATORS_ACQ_RATE_CARD_FRENCH_LOCALE = {
  title: "Taux d'acquisition",
  subtitle: "Sur 24h",
};
